import { render } from "./PagosEmpleado.vue?vue&type=template&id=64f5953c&scoped=true"
import script from "./PagosEmpleado.vue?vue&type=script&lang=js"
export * from "./PagosEmpleado.vue?vue&type=script&lang=js"

import "./PagosEmpleado.vue?vue&type=style&index=0&id=64f5953c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f5953c"]])

export default __exports__